export default __webpack_public_path__ + "static/media/LicorineTransparent.d26547e0.png";